// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"78":"5fa16924","261":"aa2f1558","338":"f3f26850","456":"02c4fe10","541":"31738ed3","544":"03c8285a","576":"1a4b2577","753":"ee88bcf7","775":"049157db","823":"d291de4a","980":"ab98845c"}[chunkId] + ".js";
};